import React from 'react'
import { useEffect, useState, useMemo, useRef } from 'react';
import '../App.css';
import '../Assets/css/Main.css'
import { Col, Row, CardHeader, Button, Card, CardBody } from 'reactstrap';
import { IoCashOutline, IoHammerOutline } from 'react-icons/io5'; import base from '../Services/BaseService'
import LoadSpinner from './Shared/Loading'
import BudgetModal from './BudgetModal'
import BudgetCreate from './BudgetModalCreate'
import Grid, { defaultGridColumnDef } from './Shared/Grid';
import { IoAddOutline } from 'react-icons/io5';
import { FormatDecimal, FormatCurrencyCell } from './Functions/NumberFormatter';

const Budget = () => {

    const gridRef = useRef();
    const [data, setData] = useState([]);
    const [saveItem, setSaveItem] = useState();
    const [budgetID, setBudgetID] = useState();
    const [showModal, setShowModal] = useState(false)
    const [showModalCreate, setShowModalCreate] = useState(false)
    const [expLoading, setExpLoading] = useState(true);
    const [remainingValue, setRemainingValue] = useState(0);

    const budgetColDef = useMemo(() => [
            {
                headerName: "Period",
                field: "period",
                suppressMovable: true,
                maxWidth: 90
            },
            {
                headerName: "Category",
                field: "categoryId",
                suppressMovable: true,
                maxWidth: 100
            },
            {
                headerName: "Category Description",
                field: "categoryDescription",
                suppressMovable: true,
                maxWidth: 200
            },
            {
                headerName: "Amount",
                field: "value",
                suppressMovable: true,
                filter: 'agNumberColumnFilter',
                type: 'numericColumn',
                maxWidth: 125,
                valueFormatter: FormatCurrencyCell
            },
            {
                headerName: "id",
                field: "id",
                suppressMovable: true,
                hide: true,
                type: 'numericColumn',
            },
        ], []);


    const openModal = () => {
        setShowModal(!showModal);
    }

    const openModalCreate = () => {
        setShowModalCreate(!showModalCreate);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const closeModalCreate = () => {
        setShowModalCreate(false);
    }

    useEffect(() => {
        const getdata = async () => {
            await base.getAll("Budget").then((budgetRes) => {

                setData(budgetRes);
            })
                .finally(() => {
                    setExpLoading(false)
                });
            await base.getAll("Dashboard/budgetremaining").then((budgetRemaining) => {
                setRemainingValue(budgetRemaining.unallocated !== null ? budgetRemaining.unallocated : 0);
            })


        }
        getdata();
    }, [saveItem])

    const quickFixExceeded = async () => {
        await base.update("Dashboard/quickfixbudget").then(() => {
            setSaveItem(new Date().getTime());

        })
    }

    const onSelectionChanged = () => {
        const selectedRows = gridRef.current.api.getSelectedRows();
        if (selectedRows.length === 1) {
            setBudgetID(selectedRows[0].id);
            openModal();
        }
    };


    return (
        <>
            <CardHeader className="pt-3 pb-3">
                <Row>
                    <Col xs="6" className="page-header">
                        Budgets
                    </Col>
                    <Col xs="6" className="text-end pe-4">
                        {!expLoading && remainingValue !== 0 && (
                            <Button size="sm" color="warning" className="me-1 btn-text" onClick={quickFixExceeded} >
                                <IoHammerOutline size={24} style={{ color: "#111" }} />
                            </Button>
                        )
                        }
                        <Button size="sm" color="dark" className="btn-text" onClick={openModalCreate} >
                            <IoAddOutline size={24} style={{ color: "#fff" }} />
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            {expLoading ?
                <LoadSpinner />
                :
                <div style={{ marginBottom: "0px" }}>
                    <div className="pt-2 pb-2 res-padding scroll-container">
                        <Row>
                            <Col xs="6" xl="2" className="">
                                <Card>
                                    <CardBody className="p-3">
                                        <div className="d-flex justify-content-between w-100">
                                            {/* Left side for the icon */}
                                            <div className="d-flex align-items-center">
                                                <IoCashOutline className="me-2 transaction-in-icon" size={45} />
                                            </div>

                                            {/* Right side for "In" label and value */}
                                            <div className="d-flex flex-column align-items-end">
                                                <div className="text-muted transaction-header">Unallocated</div>
                                                <div className="transaction-in">{FormatDecimal(remainingValue)}</div>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Grid onSelectionChanged={onSelectionChanged} gridDefaultColDef={defaultGridColumnDef} colDef={budgetColDef} data={data} gridRef={gridRef} >
                        </Grid>
                    </div>
                </div>
            }
            {showModalCreate && <BudgetCreate closeModal1={closeModalCreate} setSaveItem={setSaveItem} />}
            {showModal && <BudgetModal id={budgetID} closeModal={closeModal} setSaveItem={setSaveItem} />}
        </>
    )
}

export default Budget
